import { render } from "./ProjectCredits.vue?vue&type=template&id=2eea1e07"
import script from "./ProjectCredits.vue?vue&type=script&lang=js"
export * from "./ProjectCredits.vue?vue&type=script&lang=js"

import "./ProjectCredits.vue?vue&type=style&index=0&id=2eea1e07&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__